import React from 'react';
import Breadcrumb from '../../components/Breadcrumb';
import FaqOne from '../../components/Faq';
import DataState from '../../components/DataState';
import { useCollections } from '../../lib/api/collections';

import { faqImage as faqImg } from '../../data/images';

const FaqMain = () => {
  const content = useCollections('faq');
  if (content.loading || content.error) return <DataState state={content} />;
  const items = content.faq.map((f, i) => ({
    id: i === 0 ? 'a' : 'item-' + i,
    btnText: f.question,
    description: f.answer,
    faqImage: faqImg,
  }));
  return (
    <main>
      <Breadcrumb title="FAQs" subTitle="FAQs" />

      <div className="it-faq-area p-relative pt-120 pb-120">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="it-faq-wrap">
                <FaqOne
                  itemClass="it-custom-accordion it-custom-accordion-style-3 inner-style"
                  items={items}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};
export default FaqMain;
